import React, { useState, useEffect, useRef } from 'react';
import CheckIcon from '@rsuite/icons/Check';
import EditIcon from '@rsuite/icons/Edit';
import CloseIcon from '@rsuite/icons/Close';
import globalIP from '../../GlobelIP';
import LoadingBar from 'react-top-loading-bar';
import Upload from './upload.jpg';
import ImageIcon from '@rsuite/icons/Image';
import {
  Input,
  InputGroup,
  Table,
  Button,
  Stack,
  Breadcrumb,
  Divider,
  Message,
  Modal,
  Col,
  useToaster,
  Form,
  FlexboxGrid,
  Container,
  SelectPicker,
  IconButton,
  CheckPicker,
  InputPicker,
  InputNumber,
  Whisper,
  Tooltip,
  Pagination,
  Uploader
} from 'rsuite';
import SearchIcon from '@rsuite/icons/Search';
import ReviewRefuseIcon from '@rsuite/icons/ReviewRefuse';
import ReviewPassIcon from '@rsuite/icons/ReviewPass';
import { Link } from 'react-router-dom';
import { validateEmail2 } from '@/functions';
import axios from 'axios';
import ugr from '@/UGRoute';
import { Popconfirm } from 'antd';
import { UserChange } from '@rsuite/icons';

interface RowData {
  id: string; // or number, depending on your data
  attributes: {
    buyercode: string;
    companynm: string;
    buyernm: string;
    country: string;
    email: string;
    address: string;
    contactno: string;
    merchantnm: string;
    // Add other attributes if needed
  };
}
interface RowData1 {
  id: string; // or number, depending on your data
  attributes: {
    companynm: string;
  };
}
interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}


const data = ['Continue', 'Discontinue', 'All'].map(item => ({ label: item, value: item }));

const { Column, HeaderCell, Cell } = Table;
const AddBuyer = () => {
  const ip = globalIP;
  const toaster = useToaster();
  const [page, setPage] = useState(1);
  ////////////////  Function For 1 Start /////////////////

  const [company, setCompany] = useState({
    companynm: '',
    dis: 'Continue'
  });
  // Fetch Data from API Start
  const [companydata, setCompanydata] = useState<RowData1[]>([]);
  const [editedRowIdscompany, setEditedRowIdscompany] = useState<string[]>([]);
  const [editedDatacompany, setEditedDatacompany] = useState<
    Record<string, Partial<RowData['attributes']>>
  >({});
  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    const response = await fetch(`${ip}/api/buyer-companies?populate=*&pagination[page]=1`);
    const json = await response.json();
    const allData = [];
    for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${ip}/api/buyer-companies?populate=*&pagination[page]=${page}`
      );
      const pageJson = await pageResponse.json();
      allData.push(...pageJson.data);
    }
    setCompanydata(allData);
  };
  const handleEditRowcompany = rowData => {
    setEditedRowIdscompany(prevRowIds => [...prevRowIds, rowData.id]);
    setEditedDatacompany(prevData => ({
      ...prevData,
      [rowData.id]: { ...rowData.attributes }
    }));
  };
  const url = `${ip}/api/buyer-companies`;
  const validNameRegex = /^(?=.*[a-zA-Z])[a-zA-Z0-9 ]*$/;
  const submit = e => {
    const trimmedCompanynm = company.companynm.trim();
    const existingBuyer = companydata.find(
      item => item.attributes.companynm.toLowerCase() === trimmedCompanynm.toLowerCase()
    );

    if (trimmedCompanynm === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter Buyer Company Name.
        </Message>,
        { placement: 'topCenter' }
      );
    }
    // else if (!validNameRegex.test(trimmedCompanynm)) {
    //   toaster.push(
    //     <Message showIcon type="error">
    //       Invalid Buyer Company Name. Only alphanumeric characters and spaces are allowed.
    //     </Message>,
    //     { placement: 'topCenter' }
    //   );
    // } 
    else if (existingBuyer) {
      toaster.push(
        <Message showIcon type="warning">
          {trimmedCompanynm} already exist.
        </Message>,
        { placement: 'topCenter' }
      );
    } else {
      e.preventDefault();
      const formData = new FormData();
      formData.append('data', JSON.stringify({ ...company, companynm: trimmedCompanynm }));

      fetch(url, {
        method: 'POST',
        body: formData
      })
        .then(response => fetchData())
        .then(data => {
          // setTimeout(() => {
          //   window.location.reload();
          // }, 1000);
        })
        .catch(error => console.error(error));

      setCompany({
        companynm: '',
        dis: 'Continue'
      });

      toaster.push(
        <Message showIcon type="success">
          Data Save Successfully.
        </Message>,
        { placement: 'topCenter' }
      );
    }
  };

  //  Fetch Data from API End
  const handleInputChange = (inputName, value, index) => {
    setCompany({ ...company, [inputName]: value });
  };
  // Delete Data from API Start
  const handleDeleteRow = async rowId => {
    try {
      const response = await fetch(`${ip}/api/buyer-companies/${rowId}`, {
        method: 'DELETE'
      });
      if (response.ok) {
        // Row deletion was successful, update your local data or refresh the table
        const updatedData1 = companydata.filter(row => row.id !== rowId);
        setCompanydata(updatedData1);
        console.log('Row deleted successfully.');
      } else {
        console.log('Failed to delete row.');
      }
    } catch (error) {
      console.error('Error deleting row:', error);
    }
  };
  // Delete Data from API End
  const handleSaveRowcompany = async (rowId: string) => {
    try {
      const editedcom = editedDatacompany[rowId]?.companynm;
      const trimmedCompanynm = editedcom.trim();
      const rowData = companydata.find(row => row.id === rowId);
      if (!rowData) {
        console.error('Row data not found.');
        return;
      }
      const validNameRegex = /^(?=.*[a-zA-Z])[a-zA-Z0-9 ]*$/;
      if (!validNameRegex.test(trimmedCompanynm) || trimmedCompanynm.startsWith(' ')) {
        toaster.push(
          <Message showIcon type="error">
            Invalid Buyer Company Name. Only alphanumeric characters are allowed, and it cannot
            start with a space.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }
      const existingBuyer = companydata.find(
        item =>
          item.attributes.companynm.toLowerCase() === trimmedCompanynm.toLowerCase() &&
          item.id !== rowId
      );

      if (existingBuyer) {
        toaster.push(
          <Message showIcon type="warning">
            {trimmedCompanynm} already exists.
          </Message>,
          { placement: 'topCenter' }
        );
      } else {
        const updatedRowData: RowData1 = {
          ...rowData,
          attributes: {
            ...rowData.attributes,
            ...editedDatacompany[rowId],
            companynm: trimmedCompanynm
          }
        };
        const response = await fetch(`${ip}/api/buyer-companies/${rowData.id}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ data: updatedRowData.attributes })
        });

        if (response.ok) {
          fetchData();
          setEditedRowIdscompany(prevRowIds => prevRowIds.filter(id => id !== rowId));
        } else {
          console.error('Failed to save data');
        }
      }
    } catch (error) {
      console.error('Error occurred while saving data', error);
    }
  };

  const handleInputChangecompany = (rowId, fieldName, value) => {
    setEditedDatacompany(prevData => {
      const updatedData = { ...prevData };
      if (!updatedData[rowId]) {
        updatedData[rowId] = { ...companydata.find(row => row.id === rowId).attributes };
      }
      updatedData[rowId][fieldName] = value;
      return updatedData;
    });
  };
  ////////////////  Function For 1 End /////////////////

  ////////////////  Function For 2 Start /////////////////

  const [buyer, setBuyer] = useState({
    buyercode: '',
    companynm: '',
    buyernm: '',
    country: '',
    email: '',
    address: '',
    contactno: '',
    merchantnm: '',
    dis: 'Continue'
  });
  // Fetch Data from API Start
  const [buyerdata, setBuyerdata] = useState<RowData[]>([]);
  const [filteredbuyerdata, setFilteredBuyerdata] = useState<RowData[]>([]);
  const [buyMeta, setBuyMeta] = useState<MetaData>();
  const [editedRowIds, setEditedRowIds] = useState<string[]>([]);
  const [editedData, setEditedData] = useState<Record<string, Partial<RowData['attributes']>>>({});
  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [selectedBuyer, setSelectedBuyer] = useState('Continue');

  useEffect(() => {
    fetchData2();
  }, [selectedBuyer, page]);
  const fetchData2 = async () => {
    setProgress(30);
    if (isLoading) {
      return;
    }
    setIsLoading(true);
    let disFilter = '';
    if (selectedBuyer.length > 0) {
      disFilter = `&filters[dis][$eq]=${selectedBuyer}`;
    }
    if (selectedBuyer == 'All') {
      disFilter = '';
    }
    try {
      const response = await fetch(
        `${ip}/api/buyer-details?populate=*&pagination[page]=1&sort[0]=id${disFilter}`
      );
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${ip}/api/buyer-details?populate=*&pagination[page]=${page}&sort[0]=id:desc${disFilter}`
        );

        const pageJson = await pageResponse.json();
        allData.push(...pageJson.data);
      }
      const responseformeta = await fetch(
        `${ip}/api/buyer-details?populate=*
        `
        // &publicationState=preview
      );
      const jsonmeta = await responseformeta.json();
      setProgress(60);
      setBuyMeta(jsonmeta.meta);
      setBuyerdata(allData);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsLoading(false);
      setProgress(100);
    }
  };
  const generateNextCategoryCode = () => {
    const nextCode = buyMeta?.pagination?.total + 1;
    return `BUYER-${nextCode.toString().padStart(3, '0')}`;
  };
  const handleEditRowbuyer = rowData => {
    setEditedRowIds(prevRowIds => [...prevRowIds, rowData.id]);
    setEditedData(prevData => ({
      ...prevData,
      [rowData.id]: { ...rowData.attributes }
    }));
  };
  const url2 = `${ip}/api/buyer-details`;
  const submit2 = async (e) => {
    const validNameRegex = /^(?=.*[a-zA-Z])[a-zA-Z0-9 ]*$/;

    if (buyer.companynm === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter Buyer Company Name.
        </Message>,
        { placement: 'topCenter' }
      );
    }
    else if (!validNameRegex.test(buyer.buyernm)) {
      toaster.push(
        <Message showIcon type="error">
          Invalid Buyer Name. Only alphanumeric characters and spaces are allowed.
        </Message>,
        { placement: 'topCenter' }
      );
    } else if (buyer.buyernm === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter Buyer Name.
        </Message>,
        { placement: 'topCenter' }
      );
    } else if (buyer.country === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter Country.
        </Message>,
        { placement: 'topCenter' }
      );
    } else if (buyer.email === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter Buyer Email.
        </Message>,
        { placement: 'topCenter' }
      );
    }
    // else if (buyer.contactno === '') {
    //   toaster.push(
    //     <Message showIcon type="error">
    //       Please Enter Contact number.
    //     </Message>,
    //     { placement: 'topCenter' }
    //   );
    // } 
    else if (!(buyer.contactno.trim().length <= 12)) {
      toaster.push(
        <Message showIcon type="error">
          Please check Contact no.
        </Message>,
        { placement: 'topCenter' }
      );
      return;
    } else {
      try {

        const { data: userData } = await axios.get(
          `${ip}/api/buyer-details?populate=*&filters[buyernm][$eqi]=${buyer.buyernm.trim()}`
        );

        // Check if the username exists
        const usernameExists = userData.data.some(
          user =>
            user.attributes.buyernm.toLowerCase() === buyer.buyernm.trim().toLowerCase()
        );

        if (usernameExists) {
          toaster.push(
            <Message showIcon type="warning">
              buyer name {buyer.buyernm} already exists.
            </Message>,
            { placement: 'topCenter' }
          );
          return;
        }

        // const existingBuyer = buyerdata.find(
        //   item => item.attributes.buyernm.toLowerCase() === buyer.buyernm.toLowerCase().trim()
        // );

        // if (existingBuyer) {
        //   toaster.push(
        //     <Message showIcon type="warning">
        //       Buyer with Name {buyer.buyernm} already exists.
        //     </Message>,
        //     { placement: 'topCenter' }
        //   );
        // }
        else {
          e.preventDefault();
          const nextCategoryCode = generateNextCategoryCode();
          const formData = new FormData();
          formData.append('files.BuyerImage', buyer.BuyerImage);
          formData.append('data', JSON.stringify({ ...buyer, buyercode: nextCategoryCode }));

          const response = await fetch(url2, {
            method: 'POST',
            body: formData
          });

          if (response.ok) {
            await fetchData2(); // Wait for data to be fetched before logging
            setBuyer({
              buyercode: '',
              companynm: '',
              buyernm: '',
              country: '',
              email: '',
              address: '',
              contactno: '',
              merchantnm: '',
              dis: 'Continue'
            });
            toaster.push(
              <Message showIcon type="success">
                Data Save Successfully.
              </Message>,
              { placement: 'topCenter' }
            );
            handleClose3();
            setImageFile(null);
          } else {
            console.error('Failed to save data');
          }
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  //  Fetch Data from API End
  const handleInputChange2 = (inputName, value, index) => {
    const updatedValue = value === null ? '' : value;
    setBuyer({ ...buyer, [inputName]: updatedValue });
  };
  const handleFinC = async (catalogId, buyernm) => {
    const formData = new FormData();
    formData.append(
      'data',
      JSON.stringify({
        ...buyerdata,
        dis: 'Continue'
      })
    );
    fetch(`${ip}/api/buyer-details/${catalogId}`, {
      method: 'PUT',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        fetchData2();
        toaster.push(
          <Message showIcon type="success">
            {buyernm} Continue Successfully.
          </Message>,
          { placement: 'topEnd' }
        );
        // Refresh page after 2 seconds (2000 milliseconds)
      })
      .catch(error => {
        console.error(error);
      });
  };
  const handleFinD = async (catalogId, buyernm) => {
    const formData = new FormData();
    formData.append(
      'data',
      JSON.stringify({
        ...buyerdata,
        dis: 'Discontinue'
      })
    );
    fetch(`${ip}/api/buyer-details/${catalogId}`, {
      method: 'PUT',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        fetchData2();
        toaster.push(
          <Message showIcon type="success">
            {buyernm} Discontinue Successfully.
          </Message>,
          { placement: 'topEnd' }
        );
        // Refresh page after 2 seconds (2000 milliseconds)
      })
      .catch(error => {
        console.error(error);
      });
  };
  const confirmDiscontinue = async (catalogId, buyernm) => {
    await handleFinD(catalogId, buyernm)
  };
  const confirmcContinue = async (catalogId, buyernm) => {
    await handleFinC(catalogId, buyernm)
  }
  const cancel = e => {
    console.log("User not discontinued")
  };
  const handleBuyerC = async (catalogId, buyernm) => {
    const formData = new FormData();
    formData.append(
      'data',
      JSON.stringify({
        ...companydata,
        dis: 'Continue'
      })
    );
    fetch(`${ip}/api/buyer-companies/${catalogId}`, {
      method: 'PUT',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        fetchData();
        toaster.push(
          <Message showIcon type="success">
            {buyernm} Continue Successfully.
          </Message>,
          { placement: 'topEnd' }
        );
        // Refresh page after 2 seconds (2000 milliseconds)
      })
      .catch(error => {
        console.error(error);
      });
  };
  const handleBuyerD = async (catalogId, buyernm) => {
    const formData = new FormData();
    formData.append(
      'data',
      JSON.stringify({
        ...companydata,
        dis: 'Discontinue'
      })
    );
    fetch(`${ip}/api/buyer-companies/${catalogId}`, {
      method: 'PUT',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        fetchData();
        toaster.push(
          <Message showIcon type="success">
            {buyernm} Discontinue Successfully.
          </Message>,
          { placement: 'topEnd' }
        );
        // Refresh page after 2 seconds (2000 milliseconds)
      })
      .catch(error => {
        console.error(error);
      });
  };
  // Delete Data from API Start
  const handleDeleteRow2 = async rowId => {
    try {
      const response = await fetch(`${ip}/api/buyer-details/${rowId}`, {
        method: 'DELETE'
      });
      if (response.ok) {
        // Row deletion was successful, update your local data or refresh the table
        const updatedData1 = buyerdata.filter(row => row.id !== rowId);
        setBuyerdata(updatedData1);
        console.log('Row deleted successfully.');
      } else {
        console.log('Failed to delete row.');
      }
    } catch (error) {
      console.error('Error deleting row:', error);
    }
  };
  // Delete Data from API End
  const handleSaveRowbuyer = async (rowId: string) => {
    try {
      const editedName = editedData[rowId]?.companynm;
      const editedcountry = editedData[rowId]?.country;
      const editedbyrname = editedData[rowId]?.buyernm;
      const trimmedBuyerName = editedbyrname?.trim();

      const { data: buyerDataFromAPI } = await axios.get(
        `${ip}/api/buyer-details?filters[buyernm][$eqi]=${trimmedBuyerName}`
      );
      const buyerNameExistsInAPI = buyerDataFromAPI.data.some(
        item =>
          item.id !== rowId && // Exclude the current row
          item.attributes.buyernm.toLowerCase() === trimmedBuyerName.toLowerCase()
      );

      // const existingBuyer = buyerdata.find(
      //   item =>
      //     item.id !== rowId &&
      //     item.attributes.buyernm.toLowerCase() === trimmedBuyerName.toLowerCase()
      // );

      if (!editedName || editedName.trim() === '') {
        toaster.push(
          <Message showIcon type="error">
            Select Company
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      } else if (!editedcountry || editedcountry.trim() === '') {
        toaster.push(
          <Message showIcon type="error">
            Select Country
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      } else if (buyerNameExistsInAPI) {
        toaster.push(
          <Message showIcon type="warning">
            Buyer Name {trimmedBuyerName} already exists.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      } else {
        const rowData = buyerdata.find(row => row.id === rowId);
        if (!rowData) {
          console.error('Row data not found.');
          return;
        }
        const updatedRowData = {
          ...rowData,
          attributes: { ...editedData[rowId], buyernm: trimmedBuyerName }
        };

        delete updatedRowData.attributes.BuyerImage;
        const formData = new FormData();

        if (imageFile) {
          if (userImageId) {
            const data = await axios.delete(`${ip}/api/upload/files/${userImageId}`);
          }
          formData.append('files.BuyerImage', imageFile);
        }

        formData.append('data', JSON.stringify(updatedRowData.attributes));

        const response = await fetch(`${ip}/api/buyer-details/${rowData.id}`, {
          method: 'PUT',
          body: formData
        });

        if (response.ok) {
          fetchData2();
          setImageFile(null);
          setEditedRowIds(prevRowIds => prevRowIds.filter(id => id !== rowId));
        } else {
          console.error('Failed to save data');
        }
      }
    } catch (error) {
      console.error('Error occurred while saving data', error);
    }
  };

  const handleInputChangebuyer = (rowId, fieldName, value) => {
    if (fieldName === 'BuyerImage') {
      setImageFile(value);
    } else {
      setEditedData(prevData => {
        const updatedData = { ...prevData };
        if (!updatedData[rowId]) {
          updatedData[rowId] = { ...buyerdata.find(row => row.id === rowId).attributes };
        }
        updatedData[rowId][fieldName] = value;
        return updatedData;
      });
    }
  };
  ////////////////  Function For 2 End /////////////////

  const [open, setOpen] = React.useState(false);
  const [size, setSize] = React.useState();
  const handleOpen = value => {
    setSize(value);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleClose3 = () => setOpen(false);

  const [open1, setOpen1] = React.useState(false);
  const [size1, setSize1] = React.useState();
  const handleOpen1 = value => {
    setSize1(value);
    setOpen1(true);
  };
  const handleClose1 = () => setOpen1(false);

  // For Main Table Function Start

  const [companydataa, setCompanydataa] = React.useState([]);
  useEffect(() => {
    fetchData6();
  }, []);
  const fetchData6 = async () => {
    try {
      const response = await fetch(
        `${ip}/api/buyer-companies?&pagination[page]=1&filters[dis][$ne]=Discontinue`
      );
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${ip}/api/buyer-companies?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.companynm,
          value: item.attributes.companynm
        }));
        allData.push(...processedData);
      }
      setCompanydataa(allData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const [countrydata, setCountrydata] = useState([]);
  useEffect(() => {
    fetchDatacoutry();
  }, []);
  const fetchDatacoutry = async () => {
    try {
      const response = await fetch(
        `${ip}/api/countries?&pagination[page]=1`
      );
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${ip}/api/countries?&pagination[page]=${page}`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.countrynm,
          value: item.attributes.countrynm
        }));
        allData.push(...processedData);
      }
      setCountrydata(allData);
    } catch (error) {
      console.error('Error fetching countries data:', error);
    }
  };

  const [selectedCompany, setSelectedCompany] = useState([]);

  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = value => {
    setSearchQuery(value);
  };
  const handleComapnyChange = value => {
    setSelectedCompany(value);
  };
  const handleBuyerChange = value => {
    setSelectedBuyer(value);
  };
  const handleChangeLimit = () => {
    setPage(1);
  };
  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };
  const handleFileChange = event => {
    const file = event.target.files[0];

    if (file) {
      // Validate the file type
      const validTypes = ['image/jpeg', 'image/jpg'];
      if (!validTypes.includes(file.type)) {
        alert('Please upload a file in JPG or JPEG format.');
        return;
      }

      // Create a blob URL
      const blobFile = URL.createObjectURL(file);
      setImageFile(blobFile);

      // Call the handleImageUpload function
      handleImageUpload([{ file }]);
    }
  };
  const handleImageUpload = async fileList => {
    setBuyer({
      ...buyer,
      BuyerImage: fileList[0].file
    });
  };

  const [imageFile, setImageFile] = useState(null);
  const [userImageId, setUserImageId] = useState();

  const [merchant, setMarchant] = useState([]);

  useEffect(() => {
    fetchDatamar();
  }, []);
  const fetchDatamar = async () => {
    try {
      const response = await fetch(`${ip}/api/user-details`);
      const json = await response.json();
      const allUsers = json ? json.data : []
      const isMerchant_isActive = Array.isArray(allUsers) ?
        allUsers.filter((item) => (!item.attributes.isUserDiscontinue || item.attributes.isUserDiscontinue == null) && item.attributes.Designation == "Merchant")
        : []
      const processedData = isMerchant_isActive.map(item => ({
        label: item.attributes.Full_Name,
        value: item.attributes.UserCode
      }));
      setMarchant(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  useEffect(() => {
    setFilteredBuyerdata(buyerdata.filter(item => {
      const companynamem = item.attributes.companynm.toLowerCase();
      const byuernamem = item.attributes.buyernm.toLowerCase();
      const ContNo = item.attributes.contactno.toLowerCase();
      const email = item.attributes.email.toLowerCase();
      const country = item.attributes.country.toLowerCase();

      const camponyname = item.attributes.companynm;
      const buyername = item.attributes.buyernm;
      const categoryMatch =
        selectedCompany.length === 0 || selectedCompany.includes(camponyname);
      // const buyerMatch = selectedBuyer.length === 0 || selectedBuyer.includes(buyername);
      return (
        (companynamem.includes(searchQuery.toLowerCase()) ||
          byuernamem.includes(searchQuery.toLowerCase()) ||
          ContNo.includes(searchQuery.toLowerCase()) ||
          email.includes(searchQuery.toLowerCase()) ||
          country.includes(searchQuery.toLowerCase())) &&
        categoryMatch
        // buyerMatch
      );
    }))
  }, [buyerdata, searchQuery, selectedCompany]);
  const [tableHeight, setTableHeight] = useState(20); // Default height
  useEffect(() => {
    const calculateHeight = () => {
      const headerHeight = 300; // Adjust based on your header/footer size
      const footerHeight = 5; // Adjust based on your footer size
      const availableHeight = window.innerHeight - headerHeight - footerHeight;
      setTableHeight(availableHeight);
    };
    calculateHeight();
    window.addEventListener('resize', calculateHeight); // Recalculate on window resize
    return () => window.removeEventListener('resize', calculateHeight);
  }, []);
  return (
    <>
      <LoadingBar color="#3498ff" progress={progress} onLoaderFinished={() => setProgress(0)} />
      <Container className="main">
        <Stack className="table-toolbar  add-buyer-head" justifyContent="space-between">
          <Stack direction="column" alignItems="flex-start">
            <Stack direction="column" alignItems="flex-start">
              <h3 className="title">Manage Buyer</h3>
              <Breadcrumb>
                <Breadcrumb.Item>
                  <Link to={`/${ugr}/dashboard`}>Home</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item active>Manage</Breadcrumb.Item>
              </Breadcrumb>
            </Stack>

            <Stack spacing={5} className="add-buyer-check1">
              <CheckPicker
                data={companydataa}
                placeholder="Buyer Company Name"
                labelKey="label"
                value={selectedCompany}
                onChange={handleComapnyChange}
                valueKey="value"
                size="md"
                appearance="default"
                className="add-buyer-check"
                onOpen={fetchData6}
              />
              <Stack spacing={5}>
                <InputGroup inside className="add-buyer-srch">
                  <Input
                    placeholder="Search"
                    type="text"
                    value={searchQuery}
                    onChange={handleSearch}
                  />
                  <InputGroup.Addon>
                    <SearchIcon />
                  </InputGroup.Addon>
                </InputGroup>
              </Stack>
              <SelectPicker
                data={data}
                placeholder="Status"
                labelKey="label"
                value={selectedBuyer}
                onChange={handleBuyerChange}
                searchable={false}
                valueKey="value"
                size="md"
                appearance="default"
                style={{ width: 200 }}
                cleanable={false}
              />
            </Stack>
          </Stack>

          <Stack
            direction="column"
            alignItems="flex-end"
            spacing={16}
            style={{ marginBottom: '-26px' }}
          >
            <Stack direction="row" spacing={5} className="add-btn">
              <Button
                appearance="default"
                active
                onClick={() => handleOpen1('sm')}
                className="add-buyer-btn"
              >
                Add Buyer Company
              </Button>
              <Button color="cyan" appearance="primary" onClick={() => handleOpen('lg')}>
                Add Buyer
              </Button>
            </Stack>
          </Stack>
        </Stack>
        <Divider className="add-buyer-divider" />

        {/* <b className="total-buyer">Total Buyer: {buyMeta?.pagination?.total}</b> */}
        <Table
          height={tableHeight}
          data={filteredbuyerdata}
          rowHeight={60}
          rowKey="id"
          bordered
          cellBordered
          loading={isLoading}
        >
          <Column width={100}>
            <HeaderCell>
              <b>Sr. No.</b>
            </HeaderCell>
            <Cell>{(_, rowIndex) => rowIndex + 1}</Cell>
          </Column>

          <Column width={160}>
            <HeaderCell>
              <b>Buyer Company Name</b>
            </HeaderCell>
            <Cell>
              {rowData =>
                editedRowIds.includes(rowData.id) ? (
                  <InputPicker
                    data={companydataa}
                    value={editedData[rowData.id]?.companynm || ''}
                    onChange={value => handleInputChangebuyer(rowData.id, 'companynm', value)}
                    placement="auto"
                    onOpen={fetchData6}
                  />
                ) : (
                  rowData.attributes.companynm
                )
              }
            </Cell>
          </Column>
          <Table.Column width={150} align="center">
            <Table.HeaderCell>
              <b style={{ fontSize: '14px' }}>Image</b>
            </Table.HeaderCell>
            <Table.Cell>
              {rowData => {
                const buyerImage = rowData.attributes?.BuyerImage?.data?.attributes?.url || '';
                return editedRowIds.includes(rowData.id) ? (
                  <>
                    <div className="table-image">
                      {buyerImage ? (
                        <img
                          src={!imageFile ? `${ip}${buyerImage}` : URL.createObjectURL(imageFile)}
                          alt="Upload"
                          style={{ width: '100%', zIndex: '10000' }}
                        />
                      ) : (
                        <img
                          src={!imageFile ? `${Upload}` : URL.createObjectURL(imageFile)}
                          alt="Upload"
                          style={{ width: '100%', zIndex: '10000' }}
                        />
                      )}
                      <button>
                        <input
                          type="file"
                          accept=".jpeg, .jpg"
                          onChange={e => {
                            const file = e.target.files[0];
                            if (file && (file.type === 'image/jpeg' || file.type === 'image/jpg')) {
                              handleInputChangebuyer(rowData.id, 'BuyerImage', file);
                              setUserImageId(rowData?.attributes?.BuyerImage?.data?.id);
                            } else {
                              toaster.push(
                                <Message showIcon type="error">
                                  Please select a JPEG or JPG image.
                                </Message>
                              );
                            }
                          }}
                        />

                        <span>1</span>
                      </button>
                    </div>
                  </>
                ) : buyerImage ? (
                  <img
                    src={`${ip}${buyerImage}`}
                    alt="User Image"
                    style={{ width: 50, height: 50, marginTop: '-16px' }}
                  />
                ) : (
                  'No image'
                );
              }}
            </Table.Cell>
          </Table.Column>
          <Column width={180}>
            <HeaderCell>
              <b>Buyer Name</b>
            </HeaderCell>
            <Cell>
              {rowData =>
                editedRowIds.includes(rowData.id) ? (
                  <Input
                    value={editedData[rowData.id]?.buyernm || ''}
                    onChange={value => handleInputChangebuyer(rowData.id, 'buyernm', value)}
                  />
                ) : (
                  rowData.attributes.buyernm
                )
              }
            </Cell>
          </Column>

          <Column width={150}>
            <HeaderCell>
              <b>Country</b>
            </HeaderCell>
            <Cell>
              {rowData =>
                editedRowIds.includes(rowData.id) ? (
                  <InputPicker
                    data={countrydata}
                    value={editedData[rowData.id]?.country || ''}
                    onChange={value => handleInputChangebuyer(rowData.id, 'country', value)}
                    placement="auto"
                  />
                ) : (
                  rowData.attributes.country
                )
              }
            </Cell>
          </Column>

          <Column width={250}>
            <HeaderCell>
              <b>Email</b>
            </HeaderCell>
            <Cell>
              {rowData =>
                editedRowIds.includes(rowData.id) ? (
                  <Input
                    value={editedData[rowData.id]?.email || ''}
                    onChange={value => handleInputChangebuyer(rowData.id, 'email', value)}
                  />
                ) : (
                  rowData.attributes.email
                )
              }
            </Cell>
          </Column>

          <Column width={200}>
            <HeaderCell>
              <b>Address</b>
            </HeaderCell>
            <Cell>
              {rowData =>
                editedRowIds.includes(rowData.id) ? (
                  <Input
                    value={editedData[rowData.id]?.address || ''}
                    onChange={value => handleInputChangebuyer(rowData.id, 'address', value)}
                  />
                ) : (
                  rowData.attributes.address
                )
              }
            </Cell>
          </Column>

          <Column width={150}>
            <HeaderCell>
              <b>Contact No.</b>
            </HeaderCell>
            <Cell>
              {rowData =>
                editedRowIds.includes(rowData.id) ? (
                  <InputNumber
                    step={null}
                    value={editedData[rowData.id]?.contactno || ''}
                    onChange={value => handleInputChangebuyer(rowData.id, 'contactno', value)}
                  />
                ) : (
                  rowData.attributes.contactno
                )
              }
            </Cell>
          </Column>

          <Column width={150}>
            <HeaderCell>
              <b>Merchant</b>
            </HeaderCell>
            <Cell>
              {rowData =>
                editedRowIds.includes(rowData.id) ? (
                  <InputPicker
                    data={merchant}
                    value={editedData[rowData.id]?.merchantnm || ''}
                    onChange={value => handleInputChangebuyer(rowData.id, 'merchantnm', value)}
                    placement="auto"
                    onOpen={fetchDatamar}
                  />
                ) : (
                  merchant.find(mer => mer.value === rowData.attributes.merchantnm)
                    ?.label || ''
                )
              }
            </Cell>
          </Column>

          <Column width={100} fixed="right">
            <HeaderCell>
              <b>Action</b>
            </HeaderCell>
            <Cell>
              {rowData =>
                editedRowIds.includes(rowData.id) ? (
                  <div>
                    <IconButton
                      size="sm"
                      icon={<CheckIcon />}
                      active
                      onClick={() => handleSaveRowbuyer(rowData.id)}
                      disabled={
                        !editedData[rowData.id]?.buyernm ||
                        editedData[rowData.id]?.buyernm.trim() === '' ||
                        !editedData[rowData.id]?.companynm ||
                        editedData[rowData.id]?.companynm.trim() === ''
                        // ||
                        // !editedData[rowData.id]?.contactno ||
                        // editedData[rowData.id]?.contactno.trim() === ''
                      }
                      style={{ marginRight: '10px' }}
                    />
                    <IconButton
                      size="sm"
                      icon={<CloseIcon />}
                      active
                      onClick={() =>
                        setEditedRowIds(prevRowIds => prevRowIds.filter(id => id !== rowData.id))
                      }
                    />
                  </div>
                ) : (
                  <div>
                    <IconButton
                      size="sm"
                      icon={<EditIcon />}
                      active
                      onClick={() => handleEditRowbuyer(rowData)}
                    />
                    {rowData.attributes.dis === 'Discontinue' ? (
                      <Popconfirm
                        title="Continue Buyer"
                        description="Are you sure you want to Continue this Buyer?"
                        onConfirm={() => confirmcContinue(rowData.id, rowData.attributes.buyernm)}
                        onCancel={cancel}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Whisper speaker={<Tooltip>Continue</Tooltip>} placement='auto'>
                          <IconButton
                            size="sm"
                            icon={<UserChange />}
                            active
                            style={{ marginLeft: '10px' }}
                          // onClick={() => handleFinC(rowData.id, rowData.attributes.buyernm)}
                          />
                        </Whisper>
                      </Popconfirm>
                    ) : (
                      <Popconfirm
                        title="Discontinue Buyer"
                        description="Are you sure you want to discontinue this Buyer?"
                        onConfirm={() => confirmDiscontinue(rowData.id, rowData.attributes.buyernm)}
                        onCancel={cancel}
                        okText="Yes"
                        cancelText="No"
                      >

                        <Whisper speaker={<Tooltip>Discontinue</Tooltip>} placement='auto'>
                          <IconButton
                            size="sm"
                            icon={<ReviewPassIcon />}
                            active
                            style={{ marginLeft: '10px' }}
                          // onClick={() => handleFinD(rowData.id, rowData.attributes.buyernm)}
                          />
                        </Whisper>
                      </Popconfirm>
                    )}
                    {/* You can add a delete button as well if needed */}
                  </div>
                )
              }
            </Cell>
          </Column>
        </Table>
        <div style={{ padding: 20 }}>
          <Pagination
            prev
            next
            first
            last
            ellipsis
            boundaryLinks
            maxButtons={5}
            size="xs"
            layout={['total', '-', 'pager', 'skip']}
            // total={buyMeta?.pagination?.total || 1}
            total={filteredbuyerdata?.length}
            // total={100}
            limit={25}
            activePage={page}
            onChangePage={setPage}
            onChangeLimit={handleChangeLimit}
          />
        </div>
        {/* first modal start */}
        <Modal size={size} open={open} onClose={handleClose} backdrop="static">
          <Modal.Header>
            <Modal.Title>
              <b>Add Buyer</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form fluid>
              <FlexboxGrid justify="start">
                <FlexboxGrid.Item as={Col} colspan={24} md={8} style={{ marginBottom: '10px' }}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>
                      <Stack>
                        <p>Buyer Company Name</p>
                        <p style={{ color: 'red' }}>*</p>
                      </Stack>
                    </Form.ControlLabel>
                    <SelectPicker
                      id="companynm"
                      name="companynm"
                      size="md"
                      data={companydataa}
                      value={buyer && buyer.companynm ? buyer.companynm : ''}
                      onChange={value => handleInputChange2('companynm', value, 0)}
                      labelKey="label"
                      valueKey="value"
                      block
                      onOpen={fetchData6}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>
                      <Stack>
                        <p>Buyer Name</p>
                        <p style={{ color: 'red' }}>*</p>
                      </Stack>
                    </Form.ControlLabel>
                    <Input
                      placeholder="Buyer Name"
                      id="buyernm"
                      name="buyernm"
                      value={buyer && buyer.buyernm ? buyer.buyernm : ''}
                      onChange={value => handleInputChange2('buyernm', value, 0)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8} style={{ marginBottom: '10px' }}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>
                      <Stack>
                        <p>Country</p>
                        <p style={{ color: 'red' }}>*</p>
                      </Stack>
                    </Form.ControlLabel>
                    <SelectPicker
                      data={countrydata}
                      id="country"
                      name="country"
                      block
                      size="md"
                      value={buyer && buyer.country ? buyer.country : ''}
                      onChange={value => handleInputChange2('country', value, 0)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>
                      <Stack>Email<p style={{ color: 'red' }}>*</p></Stack>
                    </Form.ControlLabel>
                    <Input
                      id="email"
                      name="email"
                      placeholder='Email'
                      value={buyer && buyer.email ? buyer.email : ''}
                      onChange={value => handleInputChange2('email', value, 0)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8} style={{ marginBottom: '10px' }}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Address</Form.ControlLabel>
                    <Input
                      id="address"
                      name="address"
                      value={buyer && buyer.address ? buyer.address : ''}
                      onChange={value => handleInputChange2('address', value, 0)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>
                      <Stack>
                        <p>Contact No.</p>
                        {/* <p style={{ color: 'red' }}>*</p> */}
                      </Stack>
                    </Form.ControlLabel>
                    <InputNumber
                      step={null}
                      id="contactno"
                      name="contactno"
                      value={buyer && buyer.contactno ? buyer.contactno : ''}
                      onChange={value => handleInputChange2('contactno', value, 0)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Merchant</Form.ControlLabel>
                    <SelectPicker
                      id="merchantnm"
                      name="merchantnm"
                      size="md"
                      data={merchant}
                      value={buyer && buyer.merchantnm ? buyer.merchantnm : ''}
                      onChange={value => handleInputChange2('merchantnm', value, 0)}
                      labelKey="label"
                      valueKey="value"
                      block
                      onOpen={fetchDatamar}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Add Buyer Image</Form.ControlLabel>
                    <Stack>
                      {/* <Uploader
                        style={{ display: 'flex', gap: '20px' }}
                        active
                        listType="picture-text"
                        renderFileInfo={(file, fileElement) => {
                          return (
                            <>
                              <span>File Name: {file.name}</span>
                              <p>File URL: {file.url}</p>
                            </>
                          );
                        }}
                        onChange={handleImageUpload}
                        action={''}
                      >
                        <Button>Upload Image</Button>
                      </Uploader> */}
                      <Button onClick={handleButtonClick} appearance="default" active>
                        <ImageIcon /> Upload Image
                      </Button>
                      <input
                        type="file"
                        ref={fileInputRef}
                        accept=".jpg, .jpeg"
                        onChange={handleFileChange}
                        style={{ display: 'none' }} // Hide the default file input
                      />
                      {buyer.BuyerImage && (
                        <img
                          src={imageFile}
                          alt="Uploaded"
                          style={{ width: '36px', height: '36px', marginLeft: '10px' }}
                        />
                      )}
                    </Stack>
                  </Form.Group>
                </FlexboxGrid.Item>
              </FlexboxGrid>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Stack justifyContent="flex-end" spacing={10}>
              <Button onClick={handleClose3} appearance="subtle" active>
                Cancel
              </Button>
              <Button onClick={submit2} appearance="primary" color="cyan">
                Add
              </Button>
            </Stack>
          </Modal.Footer>
        </Modal>
        {/* first modal end */}

        {/* second modal start */}
        <Modal size={size1} open={open1} onClose={handleClose1} backdrop="static">
          <Modal.Header>
            <Modal.Title>
              <b>Add Buyer Company</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Stack spacing={10} style={{ marginBottom: '20px' }} justifyContent="space-between">
              <Input
                id="companynm"
                name="companynm"
                value={company && company.companynm ? company.companynm : ''}
                onChange={value => handleInputChange('companynm', value, 0)}
                onPressEnter={submit}
              />
              <Button onClick={submit} appearance="primary" color="cyan" active>
                Add
              </Button>
            </Stack>
            <Table height={380} data={companydata} bordered cellBordered rowHeight={40} rowKey="id">
              <Column width={80} align="center">
                <HeaderCell>Sr. No.</HeaderCell>
                <Cell>{(_, rowIndex) => rowIndex + 1}</Cell>
              </Column>

              <Column align="center" width={360}>
                <HeaderCell>Buyer Company Name</HeaderCell>
                <Cell>
                  {rowData =>
                    editedRowIdscompany.includes(rowData.id) ? (
                      <Input
                        style={{ marginTop: '-8px' }}
                        size="xs"
                        value={editedDatacompany[rowData.id]?.companynm || ''}
                        onChange={value => handleInputChangecompany(rowData.id, 'companynm', value)}
                      />
                    ) : (
                      <p style={{ marginTop: '-8px' }}>{rowData.attributes.companynm}</p>
                    )
                  }
                </Cell>
              </Column>

              <Column align="center" width={100}>
                <HeaderCell>Action</HeaderCell>
                <Cell>
                  {rowData =>
                    editedRowIdscompany.includes(rowData.id) ? (
                      <div>
                        <IconButton
                          size="xs"
                          icon={<CheckIcon />}
                          active
                          onClick={() => handleSaveRowcompany(rowData.id)}
                          disabled={
                            !editedDatacompany[rowData.id]?.companynm ||
                            editedDatacompany[rowData.id]?.companynm.trim() === '' ||
                            companydata.some(
                              item =>
                                item.attributes.companynm.toLowerCase() ===
                                editedDatacompany[rowData.id]?.companynm.toLowerCase() &&
                                item.id !== rowData.id
                            )
                          }
                          style={{ marginRight: '10px', marginTop: '-10px' }}
                        />
                        <IconButton
                          size="xs"
                          icon={<CloseIcon />}
                          active
                          onClick={() =>
                            setEditedRowIdscompany(prevRowIds =>
                              prevRowIds.filter(id => id !== rowData.id)
                            )
                          }
                          style={{ marginTop: '-10px' }}
                        />
                      </div>
                    ) : (
                      <div>
                        <IconButton
                          size="xs"
                          icon={<EditIcon />}
                          active
                          onClick={() => handleEditRowcompany(rowData)}
                          style={{ marginTop: '-10px' }}
                        />
                        {rowData.attributes.dis === 'Discontinue' ? (
                          // Render Discontinue button
                          <Whisper speaker={<Tooltip>Continue</Tooltip>}>
                            <IconButton
                              size="xs"
                              icon={<ReviewRefuseIcon />}
                              active
                              style={{ marginLeft: '10px', marginTop: '-10px' }}
                              onClick={() => handleBuyerC(rowData.id, rowData.attributes.companynm)}
                            />
                          </Whisper>
                        ) : (
                          // Render Continue button
                          <Whisper speaker={<Tooltip>Discontinue</Tooltip>}>
                            <IconButton
                              size="xs"
                              icon={<ReviewPassIcon />}
                              active
                              style={{ marginLeft: '10px', marginTop: '-10px' }}
                              onClick={() => handleBuyerD(rowData.id, rowData.attributes.companynm)}
                            />
                          </Whisper>
                        )}
                      </div>
                    )
                  }
                </Cell>
              </Column>
            </Table>
          </Modal.Body>
        </Modal>
        {/* second modal end */}

        <Stack
          className="copyright"
          justifyContent="flex-end"
          spacing={5}
          style={{
            position: 'fixed',
            bottom: '0',
            width: '-webkit-fill-available',
            textAlign: 'center',
            backgroundColor: 'white',
            paddingRight: '16px'
          }}
        >
          <p>© All Right Reserved. Product by </p>
          <p>
            {' '}
            <a href="https://erpdaddy.com/" target="_blank">
              ERPDaddy Software Solution.
            </a>
          </p>
        </Stack>
      </Container>
    </>
  );
};

export default AddBuyer;
